import React, { useState, useEffect, useCallback } from "react";
import {
  Grid,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableContainer,
  TableBody,
  TextField,
  withStyles,
} from "@material-ui/core";
import _ from "lodash";
import { API_URL } from "../../constants";
import * as actions from "./actions";
import Pagination from "@material-ui/lab/Pagination";
import { toastError } from "../../utils";
import CustomShowModal from "../../components/Common/CustomShowModal";

function Promotions(props) {
  const [promotions, setPromotions] = useState([]);
  const [count, setCount] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const [filters, setFilters] = useState({
    limit: 15,
    offset: 0,
    page: 1,
    search: "",
  });
  let totalPages = Math.ceil(Number(count) / filters.limit);

  const delaySearch = useCallback(
    _.debounce((filters) => onGetPromotions(filters), 500),
    []
  );

  const onPageChange = (event, page) => {
    const offset = (page - 1) * filters.limit;
    const newFilters = { ...filters, page, offset };
    setFilters(newFilters);
    onGetPromotions(newFilters);
  };

  const onGetPromotions = (filters) => {
    props.setLoader(true);
    actions
      .getCreatedPromotions(filters)
      .then((res) => {
        props.setLoader(false);
        setPromotions(res.body);
        setCount(res.total);
      })
      .catch((err) => {
        props.setLoader(false);
        toastError(err.message);
      });
  };

  const onChangeSearch = (e) => {
    const newFilters = { ...filters, search: e.target.value };
    setFilters(newFilters);
    delaySearch(newFilters);
  };

  const handleOpenModal = (image) => {
    setSelectedImage(`${API_URL}/${image}`);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedImage(null);
  };

  useEffect(() => {
    onGetPromotions(filters);
  }, []);

  return (
    <Grid container>
      <Grid item xs={12} style={{ marginBottom: "10px" }}>
        <h2 className="sub-heading">Your Promotions History</h2>
      </Grid>
      <Grid item xs={12} sm={12} md={6} style={{ marginBottom: "10px" }}>
        <TextField
          type="text"
          variant="outlined"
          size="small"
          onChange={onChangeSearch}
          value={filters.search}
          style={{ width: "100%" }}
          placeholder="Search..."
        />
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table className="universal-table">
            <TableHead>
              <TableRow>
                <TableCell align="center">No.</TableCell>
                <TableCell>Song Name</TableCell>
                <TableCell>Platform</TableCell>
                <TableCell>Promotion Type</TableCell>
                <TableCell>Playlist Name</TableCell>
                <TableCell>Playlist Link</TableCell>
                <TableCell align="center">Image</TableCell>
                <TableCell>Created On</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {promotions?.length > 0 ? (
                promotions?.map((item, key) => (
                  <TableRow hover key={key}>
                    <TableCell align="center">
                      {(filters.page - 1) * filters.limit + (key + 1)}
                    </TableCell>
                    <TableCell>{item.song}</TableCell>
                    <TableCell>{item.platform}</TableCell>
                    <TableCell>{item.type}</TableCell>
                    <TableCell>{item.playlist_name}</TableCell>
                    <TableCell>
                      <p>
                        <a
                          href={item.playlist_link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Click here
                        </a>
                      </p>
                    </TableCell>
                    <TableCell align="left" style={{ padding: 4 }}>
                      <div
                        className="album-artwork-catalog"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleOpenModal(item.image)}
                      >
                        <img
                          src={`${API_URL}/${item.image}`}
                          height="60px"
                          alt=""
                        />
                      </div>
                    </TableCell>

                    <TableCell>{item.created_at}</TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} align="center">
                    <p style={{ fontWeight: 500, fontSize: "20px" }}>
                      No Promotions Yet
                    </p>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <Pagination
            className="table-pagination"
            count={totalPages}
            showFirstButton
            showLastButton
            onChange={onPageChange}
            page={filters.page || 0}
          />
        </TableContainer>
      </Grid>
      <CustomShowModal
        open={modalOpen}
        handleClose={handleCloseModal}
        maxWidth="md"
        title="Preview Image"
      >
        <div style={{ textAlign: "center" }}>
          {selectedImage ? (
            <img
              src={selectedImage}
              alt="Preview"
              style={{ maxWidth: "100%", maxHeight: "500px" }}
            />
          ) : (
            "No image selected."
          )}
        </div>
      </CustomShowModal>
    </Grid>
  );
}

export default Promotions;
